<div class="d-flex-column" *ngIf="!this.isPixPaid">
    <div class="d-flex-column align-center">
        <b class="success-disclaimer-text">Estamos quase lá!</b>
        <p class="success-text">Falta pouco para ter acesso ao seu novo
            produto!</p>
    </div>
    <div class="d-flex-column align-center ">
        <div class="qr-code-card spacing-margin" *ngIf="this.checkoutSuccessData.pixData.file">
            <mat-card>
                <img src="data:image/png;base64,{{this.checkoutSuccessData.pixData.file}}">
            </mat-card>
        </div>
        <div class="d-flex-column align-center spacing-margin" *ngIf="this.checkoutSuccessData.pixData.qrCode">
            <p class="success-text"> Copia e cola:</p>
            <mat-card>
                <mat-card-content class="d-flex-row pix-code-card">
                    <p>{{this.checkoutSuccessData.pixData.qrCode}}</p>
                    <div>
                        <img class="icon-copy" src="/assets/images/icon-copy.svg" matTooltip="Copiar código"
                        (click)="copyContent()">
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <pme-alert type="default">
            <div class="d-flex-row align-center justify-center spacing-margin">
                <div><img class="icon-timer" src="/assets/images/fi_clock.png"></div>
                <p>
                Esse código expira em
                    <strong>
                        <pme-timer-formatter [seconds]="this.expirationTime" (onTimerComplete)=changePage()
                            (onStart)=pixPaid()>
                        </pme-timer-formatter>
                    </strong>
                </p>
            </div>
        </pme-alert>
        <div class="messages-container">
            <p class="success-text message">
                Abra o app do banco de sua preferência e escolha a opção <strong>pagar com código PIX ”Copie e cola” ou QR Code.</strong>
            </p>
            <p class="success-text message">
                Se preferir pagar pelo Internet Banking ou enviar para alguém,  <strong>basta copiar o código PIX abaixo.</strong>
            </p>
            <p class="success-text message">
                O código também foi enviado para o e-mail cadastrado.
        </div>
        <pme-alert class="spacing-margin" type="warn" title="Atenção!">
            Se o pagamento não for confirmado em até 3 dias úteis, o pedido será cancelado automaticamente.
        </pme-alert>
    </div>
</div>

<!-- PIX EXPIRADO -->
<div class="d-flex-column align-center spacing-margin" *ngIf="(this.checkoutSuccessData.pixData.chargedUser && this.timeExpired ) || (this.checkoutSuccessData.pixData.chargedUser && this.timeExpired )">
    <div class="d-flex-column align-center">
        <img src="/assets/images/expired-warn.svg">
    </div>
    <p class="success-text message spacing-margin">Código para pagamento expirou.</p>
    <p class="success-text message spacing-margin">
        Para realizar o pagamento, gere um novo código Pix.
    </p>
    <div class="spacing-margin">
        <button mat-flat-button color="success" type="submit" [disabled]="submitting"
            (click)=getPix2ndCopy()>
            <div class="display-utils-row display-utils-center-center display-utils-gap-8">
                <mat-spinner *ngIf="submitting" diameter="20" aria-label="Carregando"></mat-spinner>
                <div>Gerar novo código</div>
            </div>
        </button>
    </div>
</div>

<!-- PIX PAGO -->
<div *ngIf="this.checkoutSuccessData.pixData.chargedUser && this.isPixPaid">
    <div>
        <p class="order-sucess ">Pedido efetuado com sucesso!</p>
        <p id="font-size-14" *ngIf="this.checkoutSuccessData.contract.product.classificationIdentifier === 'plano-mensal'">
            <span>
                {{calculateFinalValue() | currency: 'R$'}} serão adicionados ao seus créditos.
            </span>
        </p>

        <p class="purchase-added-text" *ngIf="this.checkoutSuccessData.contract.product.classificationIdentifier !== 'plano-mensal'">
            <span>
                <strong>{{calculateFinalValue() | currency: 'R$'}}</strong> serão adicionados ao seus créditos.
            </span>
            <span >
                Você já pode usufruir do produto adquirido, basta clicar no botão abaixo:
            </span>
        </p>

        <br>
        <div class="button-holder"
            *ngIf="!this.checkoutSuccessData.contract.provisioningParameters.allowAutomaticRecharge || (this.checkoutSuccessData.contract.product.classificationIdentifier === 'consulta-e-recuperacao-de-dividas' && this.checkoutSuccessData.contract.provisioningParameters.allowAutomaticRecharge)">
            <button mat-flat-button (click)="redirectSuccess()">Criar senha e fazer login</button>
        </div>
        <div class="info-message-text info-atention">
            <pme-info-message type="new-info" [title]="'Atenção!'">
                <p>Sua nota fiscal será enviada dentro de <strong>5 dias úteis</strong>.</p>
            </pme-info-message>
        </div>

        <br>

    </div>
</div>

<!-- Tela de pix qnd ocorre fatura mínima -->
<div
    *ngIf="!this.checkoutSuccessData.pixData.chargedUser && (this.checkoutSuccessData.contract.status === 'ACTIVE' || this.checkoutSuccessData.contract.status === 'PAID')">
    <div class="sucess-logo">
        <img src="../../../../assets/images/feather-icons/OrderSuccess.svg">
    </div>
    <p class="order-code">Pedido {{this.checkoutSuccessData.contract.code}}</p>
    <p class="order-sucess ">Pedido efetuado com sucesso!</p>
    <p class="purchase-added-text" id="font-size-14"
        *ngIf="this.checkoutSuccessData.contract.product.classificationIdentifier === 'plano-mensal'">
        <span>
            {{calculateFinalValue() | currency: 'R$'}} serão adicionados ao seus créditos.
        </span>
    </p>

    <p class="purchase-added-text" *ngIf="this.checkoutSuccessData.contract.product.classificationIdentifier !== 'plano-mensal'">
        <span>
            <strong>{{calculateFinalValue() | currency: 'R$'}}</strong> serão adicionados ao seus créditos.
        </span>
        <span >
            Você já pode usufruir do produto adquirido, basta clicar no botão abaixo:
        </span>
    </p>

    <br>

    <p id="purchase-info">Você receberá as informações relativas à compra no email.
    </p>
</div>
